// extracted by mini-css-extract-plugin
export var infoRow = "_pe-2";
export var labelContainer = "_pe-0";
export var rightInfo = "_pe-1";